import { render, staticRenderFns } from "./TemplateEmailsView.vue?vue&type=template&id=56c24e75"
import script from "./TemplateEmailsView.vue?vue&type=script&lang=js"
export * from "./TemplateEmailsView.vue?vue&type=script&lang=js"
import style0 from "./TemplateEmailsView.vue?vue&type=style&index=0&id=56c24e75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports